// Constants
import { CurrentPlannerServiceODataVersion, HttpContentType, HttpHeaders } from "@ms/uno-constants/lib/local/HttpConstants";
// Clients
import { TokenRefreshAndRetryAjaxClient } from "./TokenRefreshAndRetryAjaxClient";
/** Ajax client for requests to planner service evo endpoint.*/ export class TasksPlatformAjaxClient extends TokenRefreshAndRetryAjaxClient {
    async executeRequest(url, options) {
        const headers = new Headers(options.headers);
        // Set the common headers for planner service requests only if they haven't been set already
        if (!headers.has(HttpHeaders.ContentType) || headers.get(HttpHeaders.ContentType) === "") {
            headers.set(HttpHeaders.ContentType, HttpContentType.Json);
        }
        if (this.includeODataVersionHeader && (!headers.has(HttpHeaders.ODataVersion) || headers.get(HttpHeaders.ODataVersion) === "")) {
            headers.set(HttpHeaders.ODataVersion, CurrentPlannerServiceODataVersion);
        }
        // Add headers to options if there is no headers set yet
        options.headers = headers;
        return await super.executeRequest(url, options);
    }
    /**
     * Initializes a new AuthRefreshAndRetryClient instance
     * @param innerAjaxClient Ajax client
     * @param authResource Resource to be used for authentication
     * @param refreshAccessToken Delegate function that returns a promise to refresh access token
     * @param silentAuth If true, the token will be acquired "silently" (without any user interaction like pop ups)
     * @param includeODataVersionHeader If true, the "OData-Version" header will be included in the request
     */ constructor(innerAjaxClient, authResource, refreshAccessToken, loggers, silentAuth, includeODataVersionHeader = true){
        super(innerAjaxClient, authResource, refreshAccessToken, loggers, silentAuth), this.includeODataVersionHeader = includeODataVersionHeader;
    }
}
